import {debug} from 'debug';

const DEBUG = 'dcs:debug';
const ERROR = 'dcs:error';
const INFO = 'dcs:info';

export const debugLog = debug(DEBUG);
export const infoLog = debug(INFO);
export const errorLog = debug(ERROR);

export const enableLog = (namespace) => debug.enable(namespace);

export const setupLogging = () => {
    if (process.env.NODE_ENV !== 'production') {
        debug.enable(DEBUG + ',' + INFO + ',' + ERROR);
    }
};